const env = {
    production: true,
    env: 'dev',
    ROOT_URL: 'https://dev-ufla.nonprod.k8s.eon.com',
    API_URL: '/api',
    ASSET_URL: '/assets',
    oauth: {
        redirectUrl: window.location.origin + window.location.pathname,
        loginUrl: 'https://westnetz-tnb-portal-dev.eon-ciam-dev.auth0app.com/authorize' +
      '?response_type=code' +
      '&client_id=0P8PfSBxhP2LzMFIq40Ly8sxIdz34x4C' +
      '&scope=offline_access' +
      '&audience=urn:westnetz:tnbportal:ufla:backend:dev' +
      '&redirect_uri=https://dev-ufla.nonprod.k8s.eon.com',
        logoutUrl: 'https://westnetz-tnb-portal-dev.eon-ciam-dev.auth0app.com/v2/logout' +
      '?client_id=0P8PfSBxhP2LzMFIq40Ly8sxIdz34x4C' +
      '&returnTo=https://dev-ufla.nonprod.k8s.eon.com',
    },
};

export const environment = env;

